const hepatitis_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## currently has signs or symptoms attributable to chronic or infectious Liver diseases?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "HEPATITIS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].Yes4[0]",
      "dbqName_no":"F[0].Page_2[0].No4[0]",
      "answer":"",
   },
   {
      "question":"Indicate signs or symptoms attributable to chronic or infectious Liver diseases?",
      "sub":"Check all that apply",
      "type":"radioModal",
      "refId": 1,
      "multi": true,
      "small": true,
      "show": false,
      "cols": 2,
      "section": {
         page: "3",
         title: "HEPATITIS",
         number: "3A"
      },
      "questions":[
         {
            "main":"Fatigue",
            "dbqName":"F[0].Page_2[0].Fatigue[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent1[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily1[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant1[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Malaise",
            "dbqName":"F[0].Page_2[0].Malaise[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent2[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily2[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant2[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Anorexia",
            "dbqName":"F[0].Page_2[0].Anorexia[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent3[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily3[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant3[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Nausea",
            "dbqName":"F[0].Page_2[0].Nausea[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent4[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily4[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant4[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Vomiting",
            "dbqName":"F[0].Page_2[0].Vomiting[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent5[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily5[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant5[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Arthralgia",
            "dbqName":"F[0].Page_2[0].Arthralgia[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent6[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily6[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant6[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Right upper quadrant pain",
            "dbqName":"F[0].Page_2[0].Rightupperquadrantpain[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_2[0].Intermittent7[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_2[0].Daily7[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_2[0].Constant7[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },  
         
         {
            "main":"Hepatomegaly",
            "dbqName":"F[0].Page_2[0].Hepatomegaly[0]",
            "answer":"",
         },
         {
            "main":"Condition requires dietary restriction",
            "dbqName":"F[0].Page_2[0].DietaryRestriction[0]",
            "answer":"",
            "showSubItems": false,
            "text1": "",
            "dbqName1": "F[0].Page_2[0].DescribeOther[3]",
            "placeholder1":"Describe dietary restriction",
            "rows1": 3,
         },
         {
            "main":"Condition results in other indications of malnutrition",
            "dbqName":"F[0].Page_2[0].Malnutrition[0]",
            "answer":"",
            "showSubItems": false,
            "text1": "",
            "dbqName1": "F[0].Page_2[0].DescribeOther[4]",
            "placeholder1":"Describe other indications of malnutrition",
            "rows1": 3,
         }, 
      ],
      "answer":""
   },

   {
      "question":"Has ##name## been diagnosed with Hepatitis C?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "HEPATITIS",
         number: "3B"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].Yes5[0]",
      "dbqName_no":"F[0].Page_2[0].No5[0]",
      "answer":"",
   },
   {
      "question":"Indicate the risk factors ?",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3B"
      },
      "questions":[
               {
                  "main":"Unknown",
                  "dbqName":"F[0].Page_2[0].B1[0]",
                  "answer":""
               },
               {
                  "main":"No known risk factors",
                  "dbqName":"F[0].Page_2[0].B2[0]",
                  "answer":""
               },
               {
                  "main":"Organ transplant before 1992",
                  "dbqName":"F[0].Page_2[0].B3[0]",
                  "answer":""
               },
               {
                  "main":"Transfusions of blood or blood products before 1992",
                  "dbqName":"F[0].Page_2[0].B4[0]",
                  "answer":""
               },
               {
                  "main":"Hemodialysis",
                  "dbqName":"F[0].Page_2[0].B5[0]",
                  "answer":""
               },
               {
                  "main":"Accidental exposure to blood by health care workers",
                  "dbqName":"F[0].Page_2[0].B6[0]",
                  "answer":""
               },
               {
                  "main":"Intravenous drug use or intranasal cocaine use",
                  "dbqName":"F[0].Page_2[0].B7[0]",
                  "answer":""
               },
               {
                  "main":"High risk sexual activity",
                  "dbqName":"F[0].Page_2[0].B8[0]",
                  "answer":""
               },
               {
                  "main":"Other direct percutaneous exposure to blood",
                  "dbqName":"F[0].Page_2[0].B9[0]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":75,
                  "textdbqName" : "F[0].Page_2[0].DescribeOther[2]",
                  "placeholder": "describe in the functional loss",
                  "textAnswer": ""
               },
               {
                  "main":"Other, describe",
                  "dbqName":"F[0].Page_2[0].B10[0]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":75,
                  "textdbqName" : "F[0].Page_2[0].DescribeOther[1]",
                  "placeholder": "describe in the functional loss",
                  "textAnswer": ""
               }         
            ],
            "answer":""
   },

   {
      "question":"Has ##name## had any incapacitating episodes due to the liver conditions in the past 12 months?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "HEPATITIS",
         number: "3C"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].Yes6[0]",
      "dbqName_no":"F[0].Page_2[0].No6[0]",
      "answer":"",
   },
   {
      "question":"Provide the total duration of the incapacitating episodes over the past 12 months",
      "sub":"Symptoms such as fatigue, malaise, nausea, vomiting, anorexia, arthralgia, and right upper quadrant pain",
      "type":"radio",
      "show": false,
      "multi": true,
      "refId": 1,
      "note":"For VA purposes, an 'Incapacitating Episode' means a period of acute symptoms severe enough to require bed rest and treatment by a physician.",
      "section": {
         page: "3",
         title: "HEPATITIS",
         number: "3C"
      },
      "questions":[
         {
            "label":"Total duration of the incapacitating episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"6 weeks or more",
                  "dbqName":"F[0].Page_2[0].C5[0]",
                  "sub":""
               },
               {
                  "main":"At least 4 weeks but less than 6 weeks",
                  "dbqName":"F[0].Page_2[0].C4[0]",
                  "sub":""
               },
               {
                  "main":"At least 2 weeks but less than 4 weeks",
                  "dbqName":"F[0].Page_2[0].C3[0]",
                  "sub":""
               },
               {
                  "main":"At least 1 week but less than 2 weeks",
                  "dbqName":"F[0].Page_2[0].C2[0]",
                  "sub":""
               },
               {
                  "main":"Less than 1 week",
                  "dbqName":"F[0].Page_2[0].C1[0]",
                  "sub":""
               }
            ],
            "answer":"Less than 1 week"
         }
      ]
   },


   {
      "question":"Does ##name## currently has signs or symptoms attributable to cirrhosis of the liver, biliary cirrhosis, or cirrhotic phase of sclerosing cholangitis?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "CIRRHOSIS OF THE LIVER, BILIARY CIRRHOSIS AND CIRRHOTIC PHASE OF SCLEROSING CHOLANGITIS",
         number: "4A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_3[0].Yes7[0]",
      "dbqName_no":"F[0].Page_3[0].No7[0]",
      "answer":"",
   },
   {
      "question":"Indicate signs or symptoms attributable to cirrhosis of the liver, biliary cirrhosis, or cirrhotic phase of sclerosing cholangitis?",
      "sub":"Check all that apply",
      "type":"radioModal",
      "refId": 1,
      "multi": true,
      "small": true,
      "show": false,
      "cols": 2,
      "section": {
         page: "4",
         title: "CIRRHOSIS OF THE LIVER, BILIARY CIRRHOSIS AND CIRRHOTIC PHASE OF SCLEROSING CHOLANGITIS",
         number: "4A"
      },
      "questions":[
         {
            "main":"Weakness",
            "dbqName":"F[0].Page_3[0].Weakness[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent8[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily8[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_3[0].Constant8[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Anorexia",
            "dbqName":"F[0].Page_3[0].Anorexia[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent9[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily9[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_3[0].Constant9[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Abdominal pain",
            "dbqName":"F[0].Page_3[0].AbdominalPain[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent10[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily10[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_3[0].Constant10[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Malaise",
            "dbqName":"F[0].Page_3[0].Malaise[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent11[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily11[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Near-constant and debilitating",
                  "dbqName":"F[0].Page_3[0].Constant11[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Ascites",
            "dbqName":"F[0].Page_3[0].Ascites[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,

            "date1": "",
            "placeholderDate1":"Date of last episode of ascites",
            "dbqDate1": "F[0].Page_3[0].Date1[6]",

            "subItems": [
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_3[0].OneEpisode[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 or more episodes",
                  "dbqName":"F[0].Page_3[0].TwoEpisodes[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"Periods of remission between attacks",
                  "dbqName":"F[0].Page_3[0].Periods[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"Refractory to treatment",
                  "dbqName":"F[0].Page_3[0].Refractory[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Hepatic encephalopathy",
            "dbqName":"F[0].Page_3[0].Hepaticencephalopathy[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,

            "date1": "",
            "placeholderDate1":"Date of last episode of Hepatic encephalopathy",
            "dbqDate1": "F[0].Page_3[0].Date1[7]",

            "subItems": [
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_3[0].OneEpisode1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 or more episodes",
                  "dbqName":"F[0].Page_3[0].TwoEpisodes1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"Periods of remission between attacks",
                  "dbqName":"F[0].Page_3[0].Periods1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"Refractory to treatment",
                  "dbqName":"F[0].Page_3[0].Refractory1[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Hemorrhage from varices or portal gastropathy",
            "dbqName":"F[0].Page_3[0].Hemorrhage[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,

            "date1": "",
            "placeholderDate1":"Date of last episode of Hemorrhage from varices",
            "dbqDate1": "F[0].Page_3[0].Date1[0]",

            "subItems": [
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_3[0].OneEpisode2[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 or more episodes",
                  "dbqName":"F[0].Page_3[0].TwoEpisodes3[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"Periods of remission between attacks",
                  "dbqName":"F[0].Page_3[0].Periods4[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"Refractory to treatment",
                  "dbqName":"F[0].Page_3[0].Refractory5[0]",
                  "colWidth": 6,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency and severity"
         },
         {
            "main":"Portal hypertension",
            "dbqName":"F[0].Page_3[0].Portalhypertension[0]",
            "answer":"",
         },
         {
            "main":"Splenomegaly",
            "dbqName":"F[0].Page_3[0].Splenomegaly[0]",
            "answer":"",
         },
         {
            "main":"Persistent jaundice",
            "dbqName":"F[0].Page_3[0].Persistentjaundice[0]",
            "answer":"",
         }
      ],
      "answer":""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":2810,
      "show": true,
      "section": {
         page: "6",
         title: "REMARKS",
         number: "9"
      },
      "options":[],
      "dbqName":"F[0].Page_5[0].Remarks[0]",
      "answer":""
   },
]
   
    export default hepatitis_questions ;